import { Injectable } from '@angular/core';

import { ApiService }                  from '../api/api.service';
import { CompanyService }              from '../companies/company.service';
import { FranchiseAccountsModel }      from './typings/franchise.accounts';
import { FranchiseModel }              from './typings/franchise';
import { FranchiseOwnerSettingsModel } from './typings/franchise.owner-settings';

@Injectable({
  providedIn: 'root'
})
export class FranchisesService {
  constructor (
    private apiService    : ApiService,
    private companyService: CompanyService
  ) {}

  create ( franchise : FranchiseModel ) : Promise<FranchiseModel> {
    return this.apiService.post('/vehicle_group_or_franchise_types', franchise, 'vehicle_group_or_franchise_type');
  }

  delete ( franchise : FranchiseModel ) : Promise<boolean> {
    return this.apiService.delete('/vehicle_group_or_franchise_type', franchise.id);
  }

  get ( id : string ) : Promise<FranchiseModel> {
    return id
      ? this.apiService.get('/vehicle_group_or_franchise_type', id)
      : Promise.resolve({} as FranchiseModel);
  }

  getAccounts () : Promise<FranchiseAccountsModel> {
    if ( this.companyService.hasIntegration('xero') ) {
      return this.apiService.get('/xero/settings')
      .then(( settings : any ) => {
        return {
          all      : settings.chart_of_accounts.all_accounts,
          assets   : settings.chart_of_accounts.revenue_accounts,
          liability: settings.chart_of_accounts.expense_accounts,
          tax      : settings.tax_rates
        };
      });
    }
    else if ( this.companyService.hasIntegration('myob') ) {
      return this.apiService.get('/myob/accounts')
      .then(( accounts : any ) => {
        return {
          all: accounts.all_accounts
        };
      });
    }
    else if ( this.companyService.hasIntegration('quickbooks') ) {
      return this.apiService.get('/quickbooks_online/accounts')
      .then(( accounts : any ) => {
        return {
          all: accounts.all_accounts
        };
      });
    }
    else {
      return Promise.resolve({
        all: []
      });
    }
  }

  getFranchises () : Promise<Array<FranchiseModel>> {
    return this.apiService.get('/vehicle_group_or_franchise_types');
  }

  getOwnerSettings () : Promise<FranchiseOwnerSettingsModel> {
    return this.apiService.get('/company_franchise_settings');
  }

  save ( franchise : FranchiseModel ) : Promise<FranchiseModel> {
    return franchise.id
      ? this.update(franchise)
      : this.create(franchise);
  }

  saveOwnerSettings ( settings : FranchiseOwnerSettingsModel ) : Promise<FranchiseOwnerSettingsModel> {
    return this.apiService.patch('/company_franchise_settings', {
      branch_shares_account: settings.branch_shares_account
    });
  }

  update ( franchise : FranchiseModel ) : Promise<FranchiseModel> {
    return this.apiService.patch('/vehicle_group_or_franchise_type', franchise, 'vehicle_group_or_franchise_type');
  }
}
